import { Navigate } from "react-router-dom";
import { useAuth } from "../Auth-Context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading, isSessionValid } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-8 h-8 border-b-2 rounded-full animate-spin border-[#009DB9]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isSessionValid()) {
    return <Navigate to="/login?reason=expired" replace />;
  }

  return children;
};

export default ProtectedRoute;